import MySelect from './select.vue';

MySelect.install = function(Vue){
  Vue.component('MySelect', MySelect);
};

export default MySelect;